<template>
    <div class="ae-list-w">
        <div class="ae-list">
            <div class="ae-item" v-for="statement in statements" :class="checkActiveClass(statement)" @click="onSelectedStatement(statement)">
                <div class="aei-image">
                    <div class="user-avatar-w"><img alt="" src="https://static.thenounproject.com/png/981231-200.png"></div>
                </div>
                <div class="aei-content">
                    <h6 class="aei-title">{{statement.statement_at}}</h6>
                    <div class="aei-sub-title">AED {{statement.net_due}}</div>
                    <div class="aei-sub-title" :class="(statement.paid_at ? 'text-success' : 'text-warning')">  {{(statement.paid_at ? 'Paid' : 'Unpaid')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['statements', 'selectedStatement'],
  methods: {
    onSelectedStatement: function (statement) {
      this.$emit('statementRailInterface', product)
    },
    checkActiveClass: function (statement) {
      if (this.selectedStatement != null) {
        return (statement.id_statement == this.selectedStatement.id_statement ? 'active' : '')
      }
    }
  }
}
</script>

<style scoped>
    h6, .h6 {
        font-size: 1rem !important;
    }
    .aei-content {
        width: 100%;
    }
    .aei-timestamp {
        color: #047bf8 !important
    }
    .ae-list-w .ae-list .aei-image .user-avatar-w img {
        display: block;
        border-radius: 0px;
        width: 50px;
        height: auto;
    }
</style>
